import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M8 21h12a2 2 0 0 0 2-2v-2H10v2a2 2 0 1 1-4 0V5a2 2 0 1 0-4 0v3h4",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(Path, { d: "M19 17V5a2 2 0 0 0-2-2H4", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M15 8h-5", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M15 12h-5", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "ScrollText";
const ScrollText = memo(themed(Icon));
export {
  ScrollText
};
//# sourceMappingURL=scroll-text.js.map
